import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Tailwind additional CSS for custom design elements
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  :root {
    --primary: 215 50% 33%;
    --primary-foreground: 0 0% 100%;
    --secondary: 19 95% 44%;
    --secondary-foreground: 0 0% 100%;
    --accent: 42 100% 67%;
    --accent-foreground: 215 50% 33%;
  }
  
  body {
    font-family: 'Open Sans', sans-serif;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Roboto', sans-serif;
  }

  .text-shadow {
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }

  .service-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.07);
  }

  .gallery-item {
    overflow: hidden;
  }

  .gallery-item img {
    transition: transform 0.5s ease;
  }

  .gallery-item:hover img {
    transform: scale(1.05);
  }
`;

const root = createRoot(document.getElementById("root")!);
root.render(
  <>
    <GlobalStyles />
    <App />
  </>
);
